module.exports = __webpack_public_path__ + "static/media/vegas-placeholder.230eb645.webp";